import Breadcrumb from '@/client/components/Breadcrumb/Breadcrumb';
import formatBreadcrumbs from '@/client/components/Breadcrumb/formatBreadcrumbs';

export { Breadcrumb, formatBreadcrumbs };
